import { useEffect, useState } from "react";
import axios from "axios";
import { TICKER_ASSETS } from "./data";
import { SessionClocks } from "@/components/home/SessionClocks";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CDN = "https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.1/svg/color";

const fmtPrice = (p) => {
  if (p == null) return "—";
  return p >= 1000 ? p.toLocaleString("en-US", { maximumFractionDigits: 0 }) : p >= 1 ? p.toFixed(2) : p.toFixed(4);
};

export const TopTicker = () => {
  const [assets, setAssets] = useState(() =>
    TICKER_ASSETS.map((a) => ({ sym: a.sym, price: a.price, chg: a.chg, up: a.up, image: null }))
  );
  const [fng, setFng] = useState(null);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/markets`);
        if (!active || !data?.coins) return;
        setAssets(
          data.coins.map((c) => {
            const up = (c.change_24h ?? 0) >= 0;
            return {
              sym: c.sym,
              price: fmtPrice(c.price),
              chg: `${up ? "+" : ""}${(c.change_24h ?? 0).toFixed(2)}%`,
              up,
              image: c.image || null,
            };
          })
        );
      } catch (e) {
        /* keep seed */
      }
    };
    const loadFng = async () => {
      try {
        const { data } = await axios.get(`${API}/fear-greed`);
        if (active && data) setFng(data);
      } catch (e) {
        /* ignore */
      }
    };
    load();
    loadFng();
    const iv = setInterval(load, 20000);
    const ivF = setInterval(loadFng, 300000);
    return () => { active = false; clearInterval(iv); clearInterval(ivF); };
  }, []);

  const fngColor = !fng
    ? "text-white/50"
    : fng.value <= 25
    ? "text-red-400"
    : fng.value <= 45
    ? "text-orange-400"
    : fng.value <= 55
    ? "text-white/70"
    : fng.value <= 75
    ? "text-[#BACD1C]"
    : "text-[#BACD1C]";

  const row = [...assets, ...assets];
  return (
    <div
      data-testid="top-ticker"
      className="fixed top-0 left-0 right-0 z-[60] h-9 bg-black border-b border-white/10 flex items-center overflow-hidden"
    >
      <div className="hidden sm:flex items-center gap-2 h-full px-3 border-r border-white/10 shrink-0 bg-black relative z-10">
        <span className="h-1.5 w-1.5 rounded-full bg-[#BACD1C] animate-pulse" />
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#B4BAC4]">Live</span>
      </div>
      <div className="flex w-max animate-marquee-slow whitespace-nowrap will-change-transform">
        {row.map((a, i) => (
          <span key={i} className="flex items-center gap-2 px-5 font-mono text-[11px]">
            <img
              src={a.image || `${CDN}/${a.sym.toLowerCase()}.svg`}
              alt=""
              className="h-3.5 w-3.5"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
            <span className="text-white/50 uppercase tracking-wider">{a.sym}</span>
            <span className="text-white/80">${a.price}</span>
            <span className={a.up ? "text-[#BACD1C]" : "text-red-400"}>
              {a.up ? "▲" : "▼"} {a.chg}
            </span>
          </span>
        ))}
      </div>
      <SessionClocks />
      <div className="hidden md:flex items-center gap-2 h-full px-4 border-l border-white/10 shrink-0 bg-black" data-testid="fear-greed-badge">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">F&amp;G</span>
        <span className={`font-mono text-[11px] ${fngColor}`}>
          {fng ? `${fng.value} · ${fng.classification}` : "— · loading"}
        </span>
      </div>
    </div>
  );
};
